module.exports = __webpack_public_path__ + "static/media/painManagementImage1.ec982b80.png";